import CreateRoute from './Pages/CreateRoute';
import { AuthProvider } from "./Utilities/authContext";
import { Routes, Route } from "react-router-dom";
import PrivacyPolicy from './Pages/Extra/PrivacyPolicy';
import TermsOfService from './Pages/Extra/TermsOfService';

function InnerApp() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<CreateRoute></CreateRoute>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy></PrivacyPolicy>} />
        <Route path="/terms-of-service" element={<TermsOfService></TermsOfService>} />
      </Routes>
    </AuthProvider>
  );
}

export default InnerApp;
